import { photoSmsLink } from "../../data/mock";
import React from "react";
import { Link } from "react-router-dom";
import { useContent, fill } from "../../lib/content";
import { FinancingBand } from "../FinancingBand";
import { Check, ArrowRight, Camera } from "lucide-react";

const WG_SMS = photoSmsLink("Hi! I'd like a White Glove quote.");

const PLAN_META = [
  {},
  { link: "/frame-tv-installation" },
  { featured: true, sms: WG_SMS, link: "/white-glove-tv-installation", linkLabel: "White Glove details" },
  { link: "/surround-sound-installation", linkLabel: "Surround install details" },
  {},
];

export const InstallPricing = () => {
  const c = useContent();
  const PLANS = c.pricing.plans.map((p, i) => ({ ...p, ...(PLAN_META[i] || {}), price: fill(p.price, c) }));
  return (
  <section data-testid="install-pricing" className="section-pad bg-[#06142e] text-white tex-grid-dark tex-glow overflow-hidden">
    <div className="max-w-[1280px] mx-auto px-5 lg:px-8">
      <span className="eyebrow !text-[#3b9dff]">{c.pricing.eyebrow}</span>
      <h2 className="mt-3 text-3xl md:text-4xl font-extrabold">{c.pricing.heading}</h2>
      <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {PLANS.map((p, i) => (
          <div key={p.name} data-testid={`plan-${i + 1}`} className={`flex flex-col rounded-2xl p-6 border backdrop-blur-md transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_40px_-12px_rgba(59,157,255,0.45)] ${PLANS.length === 5 && p.featured ? "lg:row-span-2" : ""} ${p.featured ? "bg-[#3b9dff]/10 border-[#3b9dff]" : "bg-white/5 border-white/10"}`}>
            {p.tag && <span className="text-[11px] font-bold uppercase tracking-widest text-[#3b9dff]">{p.tag}</span>}
            <h3 className="text-xl font-bold mt-1">{p.name}</h3>
            <p data-testid={`plan-${i + 1}-price`} className="mt-2 text-2xl font-extrabold text-[#3b9dff]">{p.price}</p>
            <ul className="mt-5 space-y-2.5">
              {p.pts.map((t) => (
                <li key={t} className="flex gap-2 text-sm text-slate-300 leading-relaxed"><Check className="w-4 h-4 mt-0.5 shrink-0 text-[#3b9dff]" />{t}</li>
              ))}
            </ul>
            {p.sms && (
              <a href={p.sms} data-testid="white-glove-request-btn" className="mt-6 flex items-center justify-center gap-2 w-full py-3 rounded-full bg-[#3b9dff] hover:bg-[#2b8ae8] text-white font-bold transition-colors">
                <Camera className="w-4 h-4" /> Request White Glove
              </a>
            )}
            {p.link && (
              <Link to={p.link} data-testid={`${p.name.toLowerCase().replace(/ /g, "-")}-details-link`} className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-[#3b9dff] hover:underline">
                {p.linkLabel || "Gallery install details"} <ArrowRight className="w-4 h-4" />
              </Link>
            )}
          </div>
        ))}
      </div>
      <FinancingBand dark inner="px-6" testId="pricing-financing" className="mt-8 rounded-2xl bg-white/5 border border-[#3b9dff]/40" />
    </div>
  </section>
  );
};
